export const environment = {
	production: true,
	servicesEndpointRoot: 'https://go-api-staging.naar.com/',
	i18nFiles: 'i18n/',
	azureCommunication: {
		endpoint: 'https://supportcommunicationservice.europe.communication.azure.com',
		accesskey: 'DhhJZbZnlHLwCIS4vrESBkqRzo0mkiOE4ifgKNToSNcqPwGIm7UGJQQJ99BAACULyCp5biVRAAAAAZCSqw3T'
	}
};
